import salesPlanService from "../services/salesPlan.service";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

/**
 * Channel master data for the sales plan screens — the metric columns
 * and the Areas. Fetched once and shared by the plan grid, the daily
 * entry grid and the import preview, since all three render the same
 * channel-configured columns.
 */
export const fetchSalesPlanMaster = createAsyncThunk(
	"fetchSalesPlanMaster",
	async (_arg, { rejectWithValue }) => {
		try {
			const [metricsResult, routesResult] = await Promise.all([
				salesPlanService.getMetrics(),
				salesPlanService.getRoutes(),
			]);
			return {
				channel_uuid: metricsResult?.channel_uuid ?? null,
				metrics: metricsResult?.metrics ?? [],
				routes: routesResult?.routes ?? [],
			};
		} catch (error) {
			return rejectWithValue(error?.response?.data?.message || error.message);
		}
	}
);

const salesPlanMasterSlice = createSlice({
	name: "salesPlanMasterSlice",
	initialState: {
		isLoading: false,
		channelUuid: null,
		metrics: [],
		routes: [],
		error: null,
	},
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(fetchSalesPlanMaster.pending, (state) => {
			state.isLoading = true;
			state.error = null;
		});
		builder.addCase(fetchSalesPlanMaster.fulfilled, (state, action) => {
			state.isLoading = false;
			state.channelUuid = action.payload.channel_uuid;
			state.metrics = action.payload.metrics;
			state.routes = action.payload.routes;
		});
		builder.addCase(fetchSalesPlanMaster.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload || "Unable to load the channel configuration";
		});
	},
});

export default salesPlanMasterSlice.reducer;
